import { createAction, props } from '@ngrx/store';
import { AttributeListTabModel } from '../models/attribute-list-tab.model';
import { AttributeListDataModel } from '../models/attribute-list-data.model';
import { LoadAttributeListDataResultModel } from '../models/load-attribute-list-data-result.model';
import { FeatureModel } from '@tailormap-viewer/api';
import { AttributeListInitialDataSortModel } from '../models/attribute-list-initial-data-sort.model';

const attributeListActionsPrefix = '[Attributelist]';

export const setAttributeListVisibility = createAction(
  `${attributeListActionsPrefix} Set Visibility`,
  props<{ visible?: boolean }>(),
);

export const changeAttributeListTabs = createAction(
  `${attributeListActionsPrefix} Change Tabs`,
  props<{
    newTabs: AttributeListTabModel[];
    newData: AttributeListDataModel[];
    closedTabs: string[];
  }>(),
);

export const loadData = createAction(
  `${attributeListActionsPrefix} Load Data`,
  props<{ tabId: string }>(),
);

export const loadDataSuccess = createAction(
  `${attributeListActionsPrefix} Load Data Success`,
  props<{ tabId: string; data: LoadAttributeListDataResultModel }>(),
);

export const loadDataFailed = createAction(
  `${attributeListActionsPrefix} Load Data Failed`,
  props<{ tabId: string; data: LoadAttributeListDataResultModel }>(),
);

export const setSelectedTab = createAction(
  `${attributeListActionsPrefix} Set Selected Tab`,
  props<{ tabId: string }>(),
);

export const updatePage = createAction(
  `${attributeListActionsPrefix} Update Page`,
  props<{ dataId: string; page: number }>(),
);

export const updateSort = createAction(
  `${attributeListActionsPrefix} Update Sort`,
  props<{ dataId: string; column: string; direction: 'asc' | 'desc' | '' }>(),
);

export const setInitialDataSort = createAction(
  `${attributeListActionsPrefix} Set Initial Data Sort`,
  props<{ initialDataSort: AttributeListInitialDataSortModel[] }>(),
);

export const updateRowSelected = createAction(
  `${attributeListActionsPrefix} Update Row Selected`,
  props<{ dataId: string; rowId: string; selected: boolean }>(),
);

export const setHighlightedFeature = createAction(
  `${attributeListActionsPrefix} Set Highlighted Feature`,
  props<{ feature: FeatureModel & { tabId: string } | null }>(),
);

export const changeColumnPosition = createAction(
  `${attributeListActionsPrefix} Change Column Position`,
  props<{ dataId: string; columnId: string; previousColumn: string | null}>(),
);

export const toggleColumnVisible = createAction(
  `${attributeListActionsPrefix} Toggle Column Visibility`,
  props<{ dataId: string; columnId: string }>(),
);

export const toggleAllColumnsVisible = createAction(
  `${attributeListActionsPrefix} Toggle All Columns Visibility`,
  props<{ dataId: string }>(),
);

export const setSelectedDataId = createAction(
  `${attributeListActionsPrefix} Set Selected Data Id`,
  props<{ tabId: string; dataId: string }>(),
);

export const updateRowChecked = createAction(
  `${attributeListActionsPrefix} Update Row Checked`,
  props<{ tabId: string; dataId: string; rowId: string; checked: boolean }>(),
);

export const updateAllRowsChecked = createAction(
  `${attributeListActionsPrefix} Update All Rows Checked`,
  props<{ tabId: string; dataId: string; checked: boolean }>(),
);
